import React from "react";
import { useNavigate } from "react-router-dom";
import TeamMembersRow from "../../../../../../../projects/publicView/components/teamMembersRow/teamMembersRow";

const ProjectBanner = ({ project, type }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (project?.isOwner) {
      navigate(`/projects/${project.id}/admin-view`);
    } else if (project?.isMember) {
      navigate(`/projects/${project.id}/collaborate`);
    } else {
      navigate(`/projects/${project.id}/details`);
    }
  };

  return (
    <div
      onClick={handleClick}
      className="
        w-full h-20 rounded-2xl flex items-center px-4
        bg-white hover:bg-sky-50 transition-colors duration-200
        cursor-pointer
      "
    >
      {/* Image */}
      <img
        className="w-16 h-12 rounded-[5px] object-cover flex-shrink-0"
        src={project?.image || "https://placehold.co/63x50"}
        alt={project?.title || "Project"}
      />

      {/* Content */}
      <div className="ml-4 flex items-center flex-1 min-w-0">
        {/* Title wrapper */}
        <div className="w-[200px]">
          <h3 className="text-black text-xl font-semibold font-['Inter'] truncate">
            {project?.title || "Untitled Project"}
          </h3>
        </div>

        {/* Tag wrapper */}
        <div className="w-[80px] flex justify-start ml-6">
          <span className="text-sky-800 text-xs font-medium whitespace-nowrap">
            {type === "creations" ? "Creation" : "Collaboration"}
          </span>
        </div>

        {/* Team members row */}
        <div className="ml-6 w-[140px] flex-shrink-0">
          <TeamMembersRow projectId={project?.id} />
        </div>
      </div>
    </div>
  );
};

export default ProjectBanner;
